import { useState } from 'react';
import { SessionsContent } from '@/features/sessions';
import { useSidePanelActions } from '@/app/store';
import { HistoryIcon, Repeat2Icon, ScrollTextIcon } from 'lucide-react';
import { AboutPageDialog } from '@/shared/ui';
import { TooltipProvider } from '@monksflow/monks-ui';
import {
  ListPageBody,
  ListPageLayout,
  PageHeader,
  PageHeaderIdentity,
  PageHeaderTitle,
} from '@/shared/ui/layout';
import { StaggerItem } from '@/shared/ui/animations';
import { useTranslation } from 'react-i18next';

export function Sessions() {
  const { t } = useTranslation('chats');
  const [isAboutOpen, setIsAboutOpen] = useState(false);

  // Phase D — `closeSidePanel` from `@/app/store/ui` lifted here so
  // `features/sessions/SessionsContent` stays cross-app-OUT clean.
  const { closeSidePanel } = useSidePanelActions();

  return (
    <TooltipProvider>
      <div data-testid="dashboard-layout-padded" className="page-layout">
        <ListPageLayout>
          {/* Staggered entrance mirrors the Knowledge/Projects pages so
              navigating here feels equally cohesive (MFINS-3093: header →
              description → content on the shared 50ms rhythm). */}
          <StaggerItem index={0}>
            <PageHeader>
              <PageHeaderIdentity>
                <PageHeaderTitle info={{ onClick: () => setIsAboutOpen(true) }}>
                  {t('sessions.sessions')}
                </PageHeaderTitle>
              </PageHeaderIdentity>
            </PageHeader>
          </StaggerItem>

          <ListPageBody>
            <StaggerItem index={3} className="flex min-h-0 flex-1 flex-col">
              <SessionsContent closeSidePanel={closeSidePanel} />
            </StaggerItem>
          </ListPageBody>
        </ListPageLayout>

        <AboutPageDialog
          open={isAboutOpen}
          onOpenChange={setIsAboutOpen}
          title={t('sessions.about.title')}
          description={t('sessions.about.description')}
          rows={[
            { icon: HistoryIcon, text: t('sessions.about.returnToWork') },
            { icon: Repeat2Icon, text: t('sessions.about.reusePastRuns') },
            { icon: ScrollTextIcon, text: t('sessions.about.keepRecord') },
          ]}
        />
      </div>
    </TooltipProvider>
  );
}
